import { Lightning } from '@lightningjs/sdk';
import { Block } from '../../../../block/block.component';
import { RIGHT_PADDING } from '../epg.style';
import { defaultContext, getContentHeight, getInitialStyle, getLayoutStyle } from './epg.skeleton.style';

/**
 * A loading placeholder of the HorizontalEpg block, mirroring its layout with animated rectangles
 *
 * @see ../epg.component.js
 */
export class EpgSkeleton extends Lightning.Component {
  static _template() {
    return getInitialStyle();
  }

  static getHeight({ screenSize, blockIndex }) {
    const { top, bottom } = Block.getOffsetsByBlockData({ screenSize, blockIndex, data: { title: 'mock' } });

    return getContentHeight(screenSize) + top + bottom;
  }

  _construct() {
    this._style = defaultContext;
    this._contentPadding = 0;
    this._blockIndex = 0;
  }

  _build() {
    this._updateLayout();
  }

  get rightPadding() {
    return RIGHT_PADDING[this._style.screenSize];
  }

  get contentPadding() {
    return this._contentPadding;
  }

  set contentPadding(value) {
    const contentPadding = Number.isFinite(value) ? value : 0;

    if (this._contentPadding === contentPadding) {
      return;
    }

    this._contentPadding = contentPadding;
    this._updateLayout();
  }

  // NOTE: the block index defines the top offset of the block, the rest of the data a real EPG needs is not used here
  set items(value) {
    const { blockIndex } = value || {};
    this._blockIndex = Number.isFinite(blockIndex) ? blockIndex : 0;
    this._updateLayout();
  }

  _updateLayout() {
    this.patch(
      getLayoutStyle({
        screenSize: this._style.screenSize,
        blockIndex: this._blockIndex,
        contentPadding: this._contentPadding,
      }),
    );
  }
}
